import React, { useState } from 'react';
import style from './style.module.css';

interface TruncatedTextProps {
  text: string;
  maxLength?: number;
  className?: string;
}

const TruncatedText: React.FC<TruncatedTextProps> = ({ 
  text, 
  maxLength = 100, 
  className = '' 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text || text.length <= maxLength) {
    return <span className={className}>{text}</span>;
  }

  const truncatedText = text.substring(0, maxLength);
  const displayText = isExpanded ? text : truncatedText;

  return (
    <span className={className}>
      {displayText}
      {!isExpanded && '...'}
      <button 
        className={style.toggleButton}
        onClick={() => setIsExpanded(!isExpanded)}
        type="button"
      >
        {isExpanded ? 'Read less' : 'Read more'}
      </button>
    </span>
  );
};

export default TruncatedText;